/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Coaches_OneInputs */

const en_hero_coaches_one = /** @type {(inputs: Hero_Coaches_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 coach`)
};

const pl_hero_coaches_one = /** @type {(inputs: Hero_Coaches_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 trener`)
};

/**
* | output |
* | --- |
* | "1 coach" |
*
* @param {Hero_Coaches_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_coaches_one = /** @type {((inputs?: Hero_Coaches_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Coaches_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_coaches_one(inputs)
	return en_hero_coaches_one(inputs)
});